//#region import
import React, { useState } from 'react';
// custom components //
import { BookingForm, BulkUploadForm, EmptyPage } from "_molecules";

// icons
import { IoLockClosedOutline, IoPersonOutline, IoCloudUploadOutline } from 'react-icons/io5';

// redux
import { useSelector } from 'react-redux';
import { selectUserDb } from '_redux/slices/main-screen/user';
import { selectConfirmBookingError } from '_redux/slices/prm-bookings/bookings';

// styles
import { Colors } from '_styles';
//#endregion

const MODES = [
    { key: 'single', label: 'Single Request', icon: IoPersonOutline, hint: 'One or more passengers on the same flight' },
    { key: 'bulk', label: 'Bulk Upload', icon: IoCloudUploadOutline, hint: 'Create many requests from a CSV or Excel file' },
];

const CreateBooking = () => {
    const dbUser = useSelector(selectUserDb);
    const confirmError = useSelector(selectConfirmBookingError);

    const [mode, setMode] = useState('single');

    if (!dbUser) {
        return (
            <div style={styles.emptyWrapper}>
                <div style={styles.emptyCard}>
                    <IoLockClosedOutline size={48} color={Colors.GRAY_MEDIUM} />
                    <EmptyPage
                        title="Requires Verified Account"
                        subtitle="In order to make assistance bookings your account must be verified"
                        subsubtitle="Please check back once your account has been verified"
                    />
                </div>
            </div>
        );
    }

    const activeMode = MODES.find((option) => option.key === mode) || MODES[0];

    return (
        <div style={styles.wrapper}>
            {/* Mode switcher — single request vs bulk file upload */}
            <div style={styles.tabBar} role="tablist">
                {MODES.map((option) => {
                    const Icon = option.icon;
                    const isActive = option.key === mode;
                    return (
                        <button
                            key={option.key}
                            role="tab"
                            aria-selected={isActive}
                            onClick={() => setMode(option.key)}
                            style={{
                                ...styles.tab,
                                ...(isActive ? styles.tabActive : {}),
                            }}
                        >
                            <Icon size={16} />
                            <span>{option.label}</span>
                        </button>
                    );
                })}
            </div>
            <p style={styles.tabHint}>{activeMode.hint}</p>

            {mode === 'bulk' ? <BulkUploadForm /> : <BookingForm />}

            {confirmError && (
                <div style={styles.errorBanner}>
                    <p style={styles.errorText}>{confirmError}</p>
                </div>
            )}
            <div style={{ paddingBottom: 60 }} />
        </div>
    );
};

const styles = {
    wrapper: {
        maxWidth: 960,
    },
    tabBar: {
        display: 'inline-flex',
        gap: 4,
        padding: 4,
        background: Colors.GRAY_LIGHT,
        borderRadius: 10,
        marginBottom: 8,
    },
    tab: {
        display: 'inline-flex',
        alignItems: 'center',
        gap: 8,
        padding: '9px 18px',
        border: 'none',
        borderRadius: 8,
        background: 'transparent',
        color: Colors.GRAY_DARK,
        fontSize: 14,
        fontWeight: 500,
        cursor: 'pointer',
        transition: 'all 0.15s ease',
    },
    tabActive: {
        background: '#fff',
        color: Colors.PRM_LIGHT_BLUE,
        fontWeight: 600,
        boxShadow: '0 1px 3px rgba(0,0,0,0.08)',
    },
    tabHint: {
        fontSize: 12,
        color: Colors.GRAY_DARK,
        margin: '0 0 20px 4px',
    },
    emptyWrapper: {
        display: 'flex',
        justifyContent: 'center',
        marginTop: 80,
    },
    emptyCard: {
        textAlign: 'center',
        padding: 40,
        background: Colors.GRAY_LIGHT,
        borderRadius: 16,
        maxWidth: 480,
    },
    errorBanner: {
        marginTop: 16,
        padding: '12px 16px',
        background: Colors.LIGHT_RED,
        borderRadius: 8,
        borderLeft: `4px solid ${Colors.DARK_RED}`,
    },
    errorText: {
        color: Colors.DARK_RED,
        margin: 0,
        fontSize: 14,
        fontWeight: 500,
    },
};

export default CreateBooking;
